import React, { useContext } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import styles from './RadioQuestion.module.scss';
import { AnswersContext } from '../Survey';

export default function YesNoQuestion({ _id, data: { yes, no } }) {
    const {
        submitAnswer,
        answers: { [_id]: value },
    } = useContext(AnswersContext);

    return (
        <div>
            <FormGroup id={_id} className={styles.RadioQuestion}>
                <div className={`${styles.RadioAnswer} w-100`}>
                    <Input
                        type="radio"
                        id={_id + 'Yes'}
                        name={_id}
                        title={yes}
                        value={'yes'}
                        checked={value === 'yes'}
                        onChange={(e) => submitAnswer(_id, e.target.value)}
                        className="anl_survey--yes-no-input"
                    />
                    <Label for={_id + 'Yes'}>{yes}</Label>
                </div>
                <div className={`${styles.RadioAnswer} w-100`}>
                    <Input
                        type="radio"
                        id={_id + 'No'}
                        name={_id}
                        title={no}
                        value={'no'}
                        checked={value === 'no'}
                        onChange={(e) => submitAnswer(_id, e.target.value)}
                        className="anl_survey--yes-no-input"
                    />
                    <Label for={_id + 'No'}>{no}</Label>
                </div>
            </FormGroup>
        </div>
    );
}
